import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/industries/marine-vessels/page.tsx");
